/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

import ChallengeRow from 'app/components/challenges/ChallengeRow';
import ChallengeEntryList from 'app/components/challenges/ChallengeEntryList';
import { getSportBySportId } from 'app/utils/sportsFilterUtils';
import * as columnTypes from 'app/constants/columnTypes';
import { checkUserLevel, isCasualChallenge } from 'app/utils/challengeUtils';

type Props = {
  challenges: Array<Object>,
  columns: Array<string>,
  disableRowClick: boolean,
  expandedChallengeId?: string,
  expandType?: 'edit' | 'summary' | 'view',
  history: Object,
  isDeletingChallenges?: boolean,
  onCheckBoxClick?: string => void,
  onCounterClick?: (string, string) => void,
  onExpand?: string => void,
  onNameClick?: string => void,
  selectedIds?: Array,
  showChallengeEntryState?: boolean,
  showDelete?: boolean,
  showEnter?: boolean,
  showSportsIcon?: boolean,
  sportCategories?: Object,
  sportLevels?: Object,
  isTwoThirdSize?: boolean
};

class ChallengesListBody extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    expandedChallengeId: undefined,
    expandType: undefined,
    isDeletingChallenges: false,
    onCheckBoxClick: undefined,
    onCounterClick: undefined,
    onExpand: undefined,
    onNameClick: undefined,
    selectedIds: [],
    showChallengeEntryState: true,
    showDelete: false,
    showEnter: false,
    showSportsIcon: false,
    sportCategories: undefined,
    sportLevels: {},
    isTwoThirdSize: false
  };

  render() {
    const {
      challenges,
      columns,
      disableRowClick,
      expandedChallengeId,
      expandType,
      history,
      isDeletingChallenges,
      onCheckBoxClick,
      onCounterClick,
      onExpand,
      onNameClick,
      selectedIds,
      showChallengeEntryState,
      showDelete,
      showEnter,
      showSportsIcon,
      sportCategories,
      sportLevels,
      isTwoThirdSize
    } = this.props;

    return (
      <React.Fragment>
        {challenges.map(challenge => (
          <React.Fragment key={challenge.id}>
            <ChallengeRow
              rookieOnly={challenge.rookieOnly}
              challengeId={challenge.id}
              competitionIcon={challenge.competitionIcon}
              cost={challenge.cost}
              disableRowClick={disableRowClick}
              discount={challenge.discount}
              userEntryIds={challenge.userEntryIds}
              entryCap={challenge.entryCap}
              entryCount={challenge.entryCount}
              entrantNames={challenge.entrantNames}
              expandType={expandType}
              expanded={challenge.id === expandedChallengeId}
              featured={challenge.isFeatured}
              hasCaptain={!!challenge.isCaptainContest}
              hasEntered={challenge.hasEntered}
              historyPush={history.push}
              isCasualContest={isCasualChallenge(challenge.userLevels)}
              isDeletingChallenges={isDeletingChallenges}
              isDrop1={challenge.isDrop1}
              isPrivate={challenge.isPrivate}
              isTargetChallenge={challenge.isTargetChallenge}
              isTicketChallenge={challenge.isTicketChallenge}
              isRapidfire={challenge.isRapidfire}
              isRestricted={
                !checkUserLevel(
                  challenge.userLevels,
                  get(sportLevels, `${challenge.sportId}.level`)
                )
              }
              isUnlimited={challenge.isUnlimited}
              isH2H={challenge.isH2H}
              isVisible={challenge.isVisible}
              link={challenge.link}
              maxEntriesPerPerson={challenge.maxEntriesPerPerson}
              name={challenge.name}
              onCheckBoxClick={onCheckBoxClick}
              onCounterClick={onCounterClick}
              onNameClick={onNameClick}
              onExpand={onExpand}
              ownerName={challenge.ownerName}
              ownerType={challenge.ownerType}
              payout={challenge.payout}
              payoutIcon={challenge.payoutIcon}
              payoutMessage={challenge.payoutMessage}
              payoutType={challenge.payoutType}
              points={challenge.score}
              position={challenge.rank}
              prizePool={challenge.prizePool}
              reducedCost={challenge.reducedCost}
              selected={selectedIds.includes(challenge.id)}
              showChallengeEntryState={showChallengeEntryState}
              showCheckBox={columns.includes(columnTypes.CHECK_BOX)}
              showCounter={columns.includes(columnTypes.COUNTER)}
              showPayout={columns.includes(columnTypes.PAYOUT)}
              showExpand={columns.includes(columnTypes.EXPAND)}
              showEnter={showEnter}
              showDelete={showDelete}
              showPlayerSelections={challenge.showPlayerSelections}
              showSportsIcon={showSportsIcon}
              sport={getSportBySportId(sportCategories, challenge.sportId)}
              startTime={challenge.startTime}
              statusId={challenge.statusId}
              statusLabel={challenge.statusLabel}
              userEntryCount={challenge.userEntryIds.length}
              winnings={challenge.winnings}
              won={challenge.hasWon}
              isTwoThirdSize={isTwoThirdSize}
            />
            {challenge.id === expandedChallengeId && (
              <ChallengeEntryList
                challengeId={challenge.id}
                entries={challenge.myEntries}
                expandType={expandType}
                isRacing={challenge.isRacing}
                isRapidfire={challenge.isRapidfire}
              />
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }
}

const enhancer = compose(
  withRouter,
  connect(state => ({
    sportCategories: get(state, 'sportCategories.items', []),
    sportLevels: get(state, 'user.currentUser.sport_levels')
  }))
);

export default enhancer(ChallengesListBody);
